<template>
  <div>
    <base-header class="mt-4 pb-6" type=""/>
    <b-container fluid class="mt--6">
      <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" :is-full-page="fullPage"/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>{{language_terms["SALES_ITEM_PICKING"]}}</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="3" >
                  <base-input :label="language_terms['DOC_FROM']" v-model="filter.code_from" v-on:keyup.enter="onClickSearch()"/>
                </b-col>
                <b-col md="3" >
                  <base-input :label="language_terms['DOC_TO']" v-model="filter.code_to" v-on:keyup.enter="onClickSearch()"/>
                </b-col>
                <b-col md="2" >
                  <base-input :label="language_terms['DATE_FROM']">
                    <flat-picker v-model="filter.date_from" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker" @on-change="onClickSearch()"/>                    
                  </base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['DATE_TO']">
                    <flat-picker v-model="filter.date_to" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker" @on-change="onClickSearch()"/>
                  </base-input>
                </b-col>
                <b-col cols="1" class="mt-4">
                  <base-button type="primary" @click="onClickSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                </b-col>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="tableItems.length > 0">
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>Sales Invoices</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt--4" v-if="tableItems.length > 0">
                <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['DATE']}}</b-th>
                            <b-th>{{language_terms['TIME_CREATED']}}</b-th>
                            <b-th>{{language_terms['TIME_PRINTED']}}</b-th>
                            <b-th>Time Picked</b-th>
                            <b-th>{{language_terms['INV_#']}} </b-th>
                            <!-- <b-th>{{language_terms['TYPE']}} </b-th> -->
                            <b-th>{{language_terms['CURRENCY']}} </b-th>
                            <b-th>{{language_terms['NETT_AMOUNT']}} </b-th>
                            <!-- <b-th>{{language_terms['EX_RATE']}} </b-th> -->
                            <b-th>{{language_terms['CUSTOMER']}} </b-th>
                            <b-th></b-th>
                        </b-thead>
                        <b-tbody>
                            <tr v-for="(invoice, i) in tableItems" :key="i" @click="onClickInvoice(invoice)" v-b-modal.rowDetailsModal>
                                <td :style="getRowStyle(invoice)">{{invoice.date}}</td>
                                <td :style="getRowStyle(invoice)">{{invoice.time_created}}</td>
                                <td :style="getRowStyle(invoice)">{{invoice.time_printed}}</td>
                                <td :style="getRowStyle(invoice)">{{invoice.time_picked}}</td>
                                <td :style="getRowStyle(invoice)">{{invoice.code}}</td>
                                <!-- <td>{{invoice.type}}</td> -->
                                <td :style="getRowStyle(invoice)">{{invoice.currency_code}}</td>
                                <td :style="getRowStyle(invoice)">{{(invoice.nett_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                <!-- <td :style="getRowStyle(invoice)">{{invoice.currency_exchange_rate}}</td> -->
                                <td :style="getRowStyle(invoice)">{{invoice.customer_name}}</td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>                            
            </card>
          </div>
        </b-col>
      </b-row>
      <!-- Click to Popup Item Details -->
      <b-modal id="rowDetailsModal" v-model="rowDetailsModal" size="xl" centered class="my-modal" hide-footer>
        <template>
          <div>
            <b-row class="align-items-center">
              <b-col md="12" fluid class="mt--6">
                <h6 class="h2">{{language_terms["SALES_ITEM_PICKING"]}}</h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="6">
                <base-input :label="language_terms['INV_#']" :value="selectedInvoice.code" disabled></base-input>
              </b-col>
              <b-col lg="3" md="6">
                <base-input :label="language_terms['DATE']" :value="selectedInvoice.date" disabled></base-input>
              </b-col>
              <b-col lg="3" md="6">
                <base-input :label="language_terms['SALESPERSON']" :value="selectedInvoice.salesperson_name" disabled></base-input>
              </b-col>
              <b-col lg="3" md="6">
                <base-input :label="language_terms['TYPE']" :value="selectedInvoice.type" disabled/>
              </b-col>
              <b-col lg="12">
                <base-input label="Remarks">
                  <textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3" :value="selectedInvoice.remarks"/>
                </base-input>
              </b-col>
            </b-row>
            <b-row v-if="report.rows.length > 0">
              <b-col cols="12">
                <v-client-table v-model="report.rows" :columns="report.headers" :options="vClientTableOptions" />
              </b-col>
            </b-row>
            <b-row v-if="report.rows.length > 0">
              <b-col>
                <div class="text-right">
                  <b-button variant="success" @click="onClickPrint">
                    {{language_terms['PRINT']}}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>

<script>
import moment from 'moment'
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
    }),
  },
  async mounted()
  {
    this.loadingCounter++
    if(this.id == '_new')
    {
      
    }
    else
    {
        //await this.retrieve(this.id)
    }

    this.onClickSearch()

    this.loadingCounter--
  },

  data(){
    return{
      loadingCounter: 0,
      selectedInvoice:[],
      vClientTableOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:['id','customer_id','invoice_date','customer_code','Exch Rate'],filterable:false},
      report:{headers:[], rows:[]},
      rowDetailsModal:false,
      fullPage:true,
      filter:{
        remarks:null,
        customer_name: null,
        date_from: moment().format("YYYY-MM-DD"),
        date_to: moment().format("YYYY-MM-DD"),
        code_from:null,
        code_to:null,
        time_created:null,
        type:null,
        currency_code:null,
        nett_amount:null,
        currency_exchange_rate:null,
      },
      tableItems:[],
    }
  },

  methods:
  {
    getRowStyle(invoice) {
      let style = ""
      if (invoice.time_picked != null)
        style = {color:'blue'}
      else
        style = {color:'black'}

      return(style)
    },
    async onClickPrint()
    {
      this.loadingCounter++

      let payload = {document_id:this.selectedInvoice.document_id}
      await axios
      .post(apiRoutes["SIP_PRINT"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          let url =  'https://reports.unityerp.com/esteam/sales-item-picking/' +  encodeURIComponent(localStorage.getItem('access_token')) + '/' + encodeURIComponent(this.selectedInvoice.code);
          window.open(url);
          this.onClickSearch()
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    },

    async onClickInvoice(invoice)
    {
      if(invoice)
      {
        this.selectedInvoice = invoice
        let payload = {document_id:invoice.document_id}
        await axios.post(apiRoutes['SIP_RETRIEVE_ITEMS'],payload, authHeader()).then((response)=>
        {
            if (response.data.code == 1)
            {
              this.report = response.data.data
            }
            else
            {
                this.report = [];
            }
        }
        )
        .catch((error)=> {
        if(error.response)
        {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
        });
      }
    },

    async onClickSearch()
    {
      this.loadingCounter++

      this.filter.limit = ''
      let payload = this.filter
          
      await axios
      .post(apiRoutes["SIP_QUICK_SEARCH"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          this.tableItems = response.data.data
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--

    },
  }
}
  </script>
  